import { 
    SET_MARBLES_MAP, 
    SET_RANGE_MAP, 
    LOAD_MORE_MAPS, 
    SET_MAP_CEP,
    SET_MAP_STATE,
    SET_UNLOCKED_DATA,
    CLEAR_SELECTED_STATE 
} from './types'

const mapsState = {
    street: '',
    list: [],
    range: 100,
    limit: 10,
    page: 1,
    total: 0,
    nextPage: null,
    state: '',
    states_list: [
        { value: 'AC', label: 'Acre', points: { lat: -9.9863287, lng: -67.8661161 } },
        { value: 'AL', label: 'Alagoas', points: { lat: -9.5945677, lng: -35.7567186 } },
        { value: 'AP', label: 'Amapá', points: { lat: 0.1017722, lng: -51.1669008 } },
        { value: 'AM', label: 'Amazonas', points: { lat: -3.0446598, lng: -60.037144 } },
        { value: 'BA', label: 'Bahia', points: { lat: -12.9017557, lng: -38.4901454 } },
        { value: 'CE', label: 'Ceará', points: { lat: -3.7933116, lng: -38.5896553 } },
        { value: 'DF', label: 'Distrito Federal', points: { lat: -15.721751, lng: -48.0073978 } },
        { value: 'ES', label: 'Espírito Santo', points: { lat: -20.2821881, lng: -40.3207231 } },
        { value: 'GO', label: 'Goías', points: { lat: -16.6958641, lng: -49.3743073 } },
        { value: 'MA', label: 'Maranhão', points: { lat: -2.6362531, lng: -44.4277238 } },
        { value: 'MT', label: 'Mato Grosso', points: { lat: -15.4197011, lng: -56.174593 } },
        { value: 'MS', label: 'Mato Grosso do Sul', points: { lat: -20.4810858, lng: -54.705574 } },
        { value: 'MG', label: 'Minas Gerais', points: { lat: -19.9027026, lng: -44.0340901 } },
        { value: 'PA', label: 'Pará', points: { lat: -1.3413509, lng: -48.5204216 } },
        { value: 'PB', label: 'Paraíba', points: { lat: -7.1466036, lng: -34.9516375 } },
        { value: 'PR', label: 'Paraná', points: { lat: -25.4950501, lng: -49.4298819 } },
        { value: 'PE', label: 'Pernambuco', points: { lat: -8.0433053, lng: -35.0042571 } },
        { value: 'PI', label: 'Piauí', points: { lat: -5.0937358, lng: -42.8111182 } },
        { value: 'RJ', label: 'Rio de Janeiro', points: { lat: -22.9140693, lng: -43.5860659 } },
        { value: 'RN', label: 'Rio Grande do Norte', points: { lat: -5.7999146, lng: -35.2922842 } },
        { value: 'RS', label: 'Rio Grande do Sul', points: { lat: -30.1087957, lng: -51.3172253 } },
        { value: 'RO', label: 'Rondônia', points: { lat: -8.756544, lng: -63.8899263 } },
        { value: 'RR', label: 'Roraíma', points: { lat: 2.8071985, lng: -60.731581 } },
        { value: 'SC', label: 'Santa Catarina', points: { lat: -27.5713144, lng: -48.7504622 } },
        { value: 'SP', label: 'São Paulo', points: { lat: -23.5613545, lng: -46.658683 } },
        { value: 'SE', label: 'Sergipe', points: { lat: -11.0059998, lng: -37.1731962 } },
        { value: 'TO', label: 'Tocantins', points: { lat: -10.2600522, lng:  -48.4172744 } },
    ],
    unlocked_list: []
}

const setMarblesList = (list, unlocked) => {

    let updated = list.map(item => {

        let copy = { ...item }

        let find = unlocked.find(cur => cur.id === copy.user_id)

        if (find && copy.user_id === find.id) {

            return {
              ...copy,  
              ...find
            }

        } 

        return copy

    })

    return updated

}

const updateMapsList = (oldList, currentList, unlocked) => {

    let updateCurrent = currentList.map(item => {

        let copy = { ...item }

        let find = unlocked.find(cur => cur.id === copy.user_id)

        if (find && copy.user_id === find.id) {

            return {
              ...copy,  
              ...find
            }

        } 

        return copy

    })

    const result = [ ...oldList, ...updateCurrent ]
  
    return result

}

const updateUnlockedList = (oldList, item) => {

    const result = [ ...oldList, { ...item, locked: false } ]

    let filter = result.filter((cur, i, a)=> a.findIndex(item => (item.id === cur.id) ) === i)

    return filter
}

const updateList = (oldList, item) => {

    const newList = [ ...oldList ]

    let updated = newList.map((cur) => {

        let curItem = { ...cur }

        if (cur.user_id === item.id) {
            return {
                ...curItem,
                ...item,
                locked: false
            }
        }

        return cur

    })

    return updated

}

const mapsReducer = (state, actions) => {

    const { type, payload } = actions

    switch (type) {
        case SET_MARBLES_MAP: {

            return {
                ...state,
                list: setMarblesList(payload.marbles, state.unlocked_list),
                total: payload.total,
                nextPage: payload.nextPage
            }
        }
        case SET_RANGE_MAP: {
            return {
                ...state,
                range: payload
            } 
        }
        case LOAD_MORE_MAPS: {
            return {
                ...state,
                list: updateMapsList(state.list, payload.marbles, state.unlocked_list),
                total: payload.total,
                nextPage: payload.nextPage
            }
        }
        case SET_MAP_CEP: {
            return {
                ...state,
                cep: payload
            }
        }
        case SET_MAP_STATE: {
            return {
                ...state,
                state: payload
            }
        }
        case SET_UNLOCKED_DATA: {
            return {
                ...state,
                unlocked_list: updateUnlockedList(state.unlocked_list, payload),
                list: updateList(state.list, payload)
            }
        }
        case CLEAR_SELECTED_STATE: {
            return {
                ...state,
                state: ''
            }
        }
        default: {
          return state
        }
    }

}

export { mapsReducer as default, mapsState }